import { planTypes } from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_ONE_BUNDLE),
      title: this.$t("billing.planform.title.zoom_one_biz_plus"),
      planType: planTypes.ZOOM_ONE_BUNDLE,
    };
  },
};
